var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"gutter":_vm.gutter}},_vm._l((_vm.newAudio),function(item,index){return _c('el-col',{key:_vm.rowKey ? item[_vm.rowKey] : index,attrs:{"span":_vm.setSpan ? _vm.setSpan(item, index) : _vm.span}},[_vm._t("default",null,{"row":item,"index":index,"disabled":_vm.setDisabled(item)})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }